import { useTheme } from "@mui/material/styles";
import { UpAndDownButton } from "components/shared/UpAndDown";
import Highlight from "components/ui/atoms/Highlight";
import NotePageHeader from "./NoteHeader";
import FormHeader from "components/ui/atoms/FormHeader";

const CreateFormHeader = ({}) => {
  const theme = useTheme();
  return <Highlight color={theme.palette_custom.yellow}>Create note</Highlight>;
};

const UpdateFormHeader = ({ note }) => {
  return (
    <>
      <UpAndDownButton value={note.id} />
      <NotePageHeader note={note} />
    </>
  );
};

const NoteFormHeader = ({ formType, onClose, ...props }) => {
  let header;
  if (formType == "create") header = <CreateFormHeader {...props} />;
  if (formType == "update") header = <UpdateFormHeader {...props} />;

  return <FormHeader onClose={onClose}>{header}</FormHeader>;
};

export default NoteFormHeader;
